// extracted by mini-css-extract-plugin
module.exports = {"informationContainer":"OurBrainInformation_informationContainer__1fnD0","title":"OurBrainInformation_title__1IaYH","paragraph":"OurBrainInformation_paragraph__3iQ5l"};